export const generateSessionId = (): string => {
  return `session_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
};

const TEAM = 'aicoe';

export const queryAgent = async (
  query: string,
  sessionId: string,
  identityApi: any,
  configApi: any,
): Promise<{
  response: string;
  sources?: Array<{ document_name: string; link: string }>;
}> => {
  const identity = await identityApi.getBackstageIdentity();
  const userEmail = identity?.userEntityRef.split('/')[1] || '';
  const baseUrl = configApi.getString('backend.baseUrl');

  try {
    const credentials = await identityApi.getCredentials();

    if (!credentials.token) {
      throw new Error('No authentication token available');
    }

    const decoded = JSON.parse(atob(credentials.token.split('.')[1])) as {
      displayName?: string;
    };
    const userName = decoded.displayName || userEmail;

    const response = await fetch(
      `${baseUrl}/api/custom-api/ai/query`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${credentials.token}`,
        },
        body: JSON.stringify({
          query,
          session_id: sessionId,
          email: userEmail,
          user_name: userName,
          team: TEAM,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return {
      response: data.response || 'Sorry, I could not get a response.',
      sources: data.sources,
    };
  } catch (error) {
    console.error('API Error:', error);
    return {
      response: 'Sorry, there was an error connecting to the AI assistant.',
    };
  }
};
